// extracted by mini-css-extract-plugin
module.exports = {"increaseButton":"style_increaseButton__3RtJb","button":"style_button__1vLIy","plusIcon":"style_plusIcon__2wKUb","increaseItem":"style_increaseItem__3FicY"};